// src/api/apiRoutes.js
 
// 10.212.134.101 10.212.134.102 10.245.47.75(este es en la ofi)
//10.212.134.100 10.245.98.13
//const API_BASE = "http://10.245.96.98:8082/flpa/api"; //local
//const API_BASE = "http://10.245.98.13:8082/flpa/api";//DESA
//const API_BASE = "http://10.245.96.193:8082/flpa/api"; //Oficina

const API_BASE = "/flpa/api"; //PRD

const apiRoutes = {
  login: {
    challenge: `${API_BASE}/login/challenge`,
    auth: `${API_BASE}/login`
  },
  // 🔐 Auth
  auth: {
    keepAlive: `${API_BASE}/auth/keep-alive`,
  },

  monedas: {
    create: `${API_BASE}/moneda/agregar`,
    update: (id) => `${API_BASE}/moneda/${id}/editar`,
    delete: (id) => `${API_BASE}/moneda/${id}/eliminar`,
    listUrl: ({ page = 0, size = 30, codigo = "", nombre = "", valorCambio = "", codigoIso = "" } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        params.set("size", String(size));
        if (codigo) params.set("codigo", codigo.trim());
        if (nombre) params.set("nombre", nombre.trim());
        if (valorCambio) params.set("valorCambio", String(valorCambio));
        if (codigoIso) params.set("codigoIso", String(codigoIso));
        return `${API_BASE}/moneda/list?${params.toString()}`;
    },
},

  ciudades: {
    create: `${API_BASE}/ciudad/agregar`,
    update: (id) => `${API_BASE}/ciudad/${id}/editar`,
    delete: (id) => `${API_BASE}/ciudad/${id}/eliminar`,
    listUrl: ({ page = 0, size = 30, nombre = "", codigo = "", nombrePais = "", departamentoId = "" } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        params.set("size", String(size));
        if (nombre) params.set("nombre", nombre.trim());
        if (codigo) params.set("codigo", codigo.trim());
        if (nombrePais) params.set("nombrePais", nombrePais.trim());
        if (departamentoId) params.set("departamentoId", String(departamentoId));
        return `${API_BASE}/ciudad/list?${params.toString()}`;
    },
},

  departamentos: {
    create: `${API_BASE}/departamento/agregar`,
    update: (id) => `${API_BASE}/departamento/${id}/editar`,
    delete: (id) => `${API_BASE}/departamento/${id}/eliminar`,
    listUrl: ({ page = 0, size = 30, nombre = "", codigo = "" } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        params.set("size", String(size));
        if (nombre) params.set("nombre", nombre.trim());
        if (codigo) params.set("codigo", codigo.trim());
        return `${API_BASE}/departamento/list?${params.toString()}`;
    },
    autocomplete: (q = "", page = 0, size = 20) =>
    `${API_BASE}/departamento/autocomplete?q=${encodeURIComponent(q)}&page=${page}&size=${size}`,
},

//Marca
marcas: {
    create: `${API_BASE}/marca/agregar`,
    update: (id) => `${API_BASE}/marca/${id}/editar`,
    delete: (id) => `${API_BASE}/marca/${id}/eliminar`,
    listUrl: ({
      page = 0,
      size = 30,
      descricao = "",
    } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if (descricao) params.set("descricao", descricao.trim());
      return `${API_BASE}/marca/list?${params.toString()}`;
    },
},

  contratoTarjeta: {
  base: `${API_BASE}/contratoTarjeta`,
  listUrl: ({ page = 0, size = 25, ...filters } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("size", String(size));
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== "") {
        params.set(key, String(value).trim());
      }
    });
    return `${API_BASE}/contratoTarjeta/list?${params.toString()}`;
  },
  agregarUrl: () => `${API_BASE}/contratoTarjeta/agregar`,
  editarUrl: (id) => `${API_BASE}/contratoTarjeta/${id}/editar`,
  eliminarUrl: (id) => `${API_BASE}/contratoTarjeta/${id}/eliminar`,
},

  contratoDetalle: {
  base: `${API_BASE}/contratosDetalle`,
  listUrl: ({ page = 0, size = 25, ...filters } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("size", String(size));
    Object.entries(filters).forEach(([key, value]) => {
      if (value !== null && value !== undefined && String(value).trim() !== "") {
        params.set(key, String(value).trim());
      }
    });
    return `${API_BASE}/contratosDetalle/list?${params.toString()}`;
  },
  agregarUrl: () => `${API_BASE}/contratosDetalle/agregar`,
  editarUrl: (id) => `${API_BASE}/contratosDetalle/${id}/editar`,
  eliminarUrl: (id) => `${API_BASE}/contratosDetalle/${id}/eliminar`,
},

  // Contratos
contratos: {
  base: `${API_BASE}/contratos`,

  listUrl: ({ page = 0, size = 25, sort, codigo, descricaoTexto, data, dataFechaini, dataFechafin } = {}) => {
    const params = new URLSearchParams();
    params.set("page", String(page));
    params.set("size", String(size));
    if (sort) params.set("sort", sort);
    if (codigo) params.set("codigo", codigo.trim());
    if (descricaoTexto) params.set("descricaoTexto", descricaoTexto.trim());
    if (data) params.set("data", data);
    if (dataFechaini) params.set("dataFechaini", dataFechaini);
    if (dataFechafin) params.set("dataFechafin", dataFechafin);
    return `${API_BASE}/contratos/list?${params.toString()}`;
  },

  //CÓDIGO CONTRATO AUTOCOMPLETE
  autocomplete: (q = "", page = 0, size = 30) => {
    const params = new URLSearchParams();
    if (q) params.append("q", q);
    params.append("page", String(page));
    params.append("size", String(size));
    return `${API_BASE}/contratos/autocomplete?${params.toString()}`;
  },

  //DESCRIPCIÓN CONTRATO AUTOCOMPLETE
  autocompleteDescripcion: (q, page = 0, size = 30) => {
  const params = new URLSearchParams();
  if (q) params.append("q", q);
  params.append("page", String(page));
  params.append("size", String(size));
  return `${API_BASE}/contratos/autocomplete-descripcion?${params.toString()}`;
},

  agregarUrl: () => `${API_BASE}/contratos/agregar`,
  editarUrl: (id) => `${API_BASE}/contratos/${id}/editar`,
  eliminarUrl: (id) => `${API_BASE}/contratos/${id}/eliminar`,
},

  // 💳 Transacciones Bancard
  transaccionBancard: {
    // Esta función recibe el objeto con { page, size, ...filtros } y devuelve la URL completa
    listUrl: (params = {}) => {
      // 1. Limpieza: Eliminamos claves con valores null, undefined o vacíos ""
      const cleanParams = Object.fromEntries(
        Object.entries(params).filter(([_, v]) => v != null && v !== "")
      );
      
      // 2. Construcción: Convertimos a string query (ej: "page=0&size=30&numeroTarjeta=123")
      const queryString = new URLSearchParams(cleanParams).toString();
      
      // 3. Retorno: URL final
      return `${API_BASE}/transaccionBancard/list?${queryString}`;
    },
    retrieveUrl: (id) => `${API_BASE}/transaccionBancard/get/${id}`,
  },

  //Auditoría
  auditoria: {
    base: `${API_BASE}/auditoria`, 
    
    // Helper para generar la URL con query params (Igual que en remitos)
    listUrl: ({ page = 0, size = 25, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      Object.entries(filters).forEach(([key, value]) => {
        // Filtramos nulos, undefined o strings vacíos
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });
      
      return `${API_BASE}/auditoria/list?${params.toString()}`;
    },
    retrieveUrl: (id) => `${API_BASE}/auditoria/get/${id}`
  },

certificadoCliente: {
    list: `${API_BASE}/certificadoCliente/list`,
    create: `${API_BASE}/certificadoCliente/guardar`,
    deleteUrl: (id) => `${API_BASE}/certificadoCliente/delete/${id}`,

    // Helper para URL con parámetros (Copiado de tu patrón)
    listUrl: ({ page = 0, size = 30, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });
      return `${API_BASE}/certificadoCliente/list?${params.toString()}`;
    },
  },

  // 💧 Liquidacion Ejecucion
  liquidacionEjecucion: {
    list: `${API_BASE}/liquidacionEjecucion/list`, 
    detail: (id) => `${API_BASE}/liquidacionEjecucion/${id}`,
    update: (id) => `${API_BASE}/liquidacionEjecucion/${id}/editar`, // ✅ NUEVO
    autocomplete: (q = "", page = 0, size = 100) =>
      `${API_BASE}/liquidacionEjecucion/autocomplete?q=${encodeURIComponent(
        q
      )}&page=${page}&size=${size}`,

    //Resumen liquidacion
    exportarResumenExcel: (params) => `${API_BASE}/liquidacionEjecucion/exportarResumenLiquidacionExcel?${params.toString()}`,
    exportarResumenPdf: (params) => `${API_BASE}/liquidacionEjecucion/exportarResumenLiquidacionPDF?${params.toString()}`,
  },

  // 📄 Detalles de Remito (Items/Productos)
  remitoDetalles: {
    list: (remitoId) => `${API_BASE}/remitoDetalle/list?remitoId=${remitoId}`,
  },

  // 🧾 Transacciones (Remitos)
  transacciones: {
    remitos: `${API_BASE}/remitos/list`,

     // --- HELPER AGREGADO ---
    listUrl: ({ page = 0, size = 25, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      Object.entries(filters).forEach(([key, value]) => {
        // Filtramos valores nulos o vacíos
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });
      
      return `${API_BASE}/remitos/list?${params.toString()}`;
    },
    // --- DETALLE UTILIZACION TARJETA ---
    exportar: (params) => `${API_BASE}/remitos/exportarDetalleUtilizacionTarjetaExcel?${params.toString()}`,
    exportarPdf: (params) => `${API_BASE}/remitos/exportarDetalleUtilizacionTarjetaPDF?${params.toString()}`,

    // --- DETALLE UTILIZACION TARJETA DESCUENTO ---
    exportarDescuento: (params) => `${API_BASE}/remitos/exportarUtilizacionTarjetaConDescuentoExcel?${params.toString()}`,
    exportarDescuentoPdf: (params) => `${API_BASE}/remitos/exportarUtilizacionTarjetaConDescuentoPDF?${params.toString()}`,

    // --- DETALLE UTILIZACION TARJETA DESCUENTO ISC ---
    exportarDescuentoISC: (params) => `${API_BASE}/remitos/exportarDescuentoISCExcel?${params.toString()}`,
    exportarDescuentoISCPdf: (params) => `${API_BASE}/remitos/exportarDescuentoISCPdf?${params.toString()}`,
    exportarDescuentoISCPdfCalco: (params) => `${API_BASE}/remitos/exportarDescuentoISCPdfCalcoExcel?${params.toString()}`,
    
    // --- DETALLE TRANSACCIONES MANUALES ---
    exportarTransaccionesManualesExcel: (params) => `${API_BASE}/remitos/exportarDetalleTransaccionesManualesExcel?${params.toString()}`,
    exportarTransaccionesManualesPDF: (params) => `${API_BASE}/remitos/exportarDetalleTransaccionesManualesPDF?${params.toString()}`,

    // // --- DETALLE UTILIZACION TARJETA EESS ---
   exportarEessExcel: (params) => `${API_BASE}/remitos/exportarDetalleUtilizacionTarjetaEessExcel?${params.toString()}`,
   exportarEessPdf: (params) => `${API_BASE}/remitos/exportarDetalleUtilizacionTarjetaEessPDF?${params.toString()}`,
  },

  certificadoDetalles: {
    list: `${API_BASE}/certificadoDetalles/list`,
    create: `${API_BASE}/certificadoDetalles/agregar`,
    update: (id) => `${API_BASE}/certificadoDetalles/${id}/editar`,
    deleteUrl: (id) => `${API_BASE}/certificadoDetalles/${id}/eliminar`,

    // Helper para URL con parámetros
    listUrl: ({ page = 0, size = 25, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });
      return `${API_BASE}/certificadoDetalles/list?${params.toString()}`;
    },
  },

certificados: {
    // Rutas estáticas básicas
    list: `${API_BASE}/certificados/list`,
    create: `${API_BASE}/certificados/agregar`,
    
    // Para editar/eliminar, como el Controller pide el ID en la URL (/{id}/editar),
    // es mejor definirlas como funciones:
    updateUrl: (id) => `${API_BASE}/certificados/${id}/editar`,
    deleteUrl: (id) => `${API_BASE}/certificados/${id}/eliminar`,

    // Listar con paginación y FILTROS DINÁMICOS
    // Esto captura automáticamente: numero, data, dataFechaini, dataFechafin, dataIngreso
    listUrl: ({ page = 0, size = 25, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      // Iteramos sobre el resto de filtros que vengan en el objeto (numero, fechas, etc.)
      Object.entries(filters).forEach(([key, value]) => {
        // Solo agregamos si tiene valor real
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });

      return `${API_BASE}/certificados/list?${params.toString()}`;
    },
  },
  
  precioProductoEessFuturo: {
    list: `${API_BASE}/precioProductoEessFuturo/list`,
    create: `${API_BASE}/precioProductoEessFuturo/agregar`,
    update: `${API_BASE}/precioProductoEessFuturo/editar`,
    delete: (id) => `${API_BASE}/precioProductoEessFuturo/${id}/eliminar`,

    // Helper para generar URL con filtros
    listUrl: ({ page = 0, size = 10, q = "", eessId="", productoId="", usuarioId="", ...others } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if (q) params.set("q", q);
      if (eessId) params.set("eessId", eessId);
      if (productoId) params.set("productoId", productoId);
      // ... otros filtros ...
      
      return `${API_BASE}/precioProductoEessFuturo/list?${params.toString()}`;
    },
  },
 
  bonificacion: {
    // Endpoints básicos
    list: `${API_BASE}/bonificacion/list`,
    create: `${API_BASE}/bonificacion/agregar`,
    update: (id) => `${API_BASE}/bonificacion/${encodeURIComponent(id)}/editar`,
    delete: (id) => `${API_BASE}/bonificacion/${encodeURIComponent(id)}/eliminar`,
 
    // Generador de URL con filtros (Page, Size, Q, Nombre, RubroId, EessId)
    listUrl: ({ page = 0, size = 10, q = "", nombre = "", rubroId = "", eessId = "" } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
 
      // Filtro general 'q'
      if ((q ?? "").trim() !== "") {
        params.set("q", q.trim());
      }
 
      // Filtro específico 'nombre'
      if ((nombre ?? "").trim() !== "") {
        params.set("nombre", nombre.trim());
      }
 
      // --- NUEVOS FILTROS ---
      if (rubroId) {
        params.set("rubroId", String(rubroId));
      }
     
      if (eessId) {
        params.set("eessId", String(eessId));
      }
      // ----------------------
 
      return `${API_BASE}/bonificacion/list?${params.toString()}`;
    },
  },
 
precioProductoEess: {
    // Listar (simple, por consistencia)
    list: `${API_BASE}/precioProductoEess/list`,
    create: `${API_BASE}/precioProductoEess/agregar`,
    update: `${API_BASE}/precioProductoEess/editar`,
 
    // Listar con paginación y FILTROS DINÁMICOS
    listUrl: ({ page = 0, size = 30, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
 
      // Iteramos sobre el resto de filtros (q, eessId, productoId, fecha, precio, etc.)
      Object.entries(filters).forEach(([key, value]) => {
        // Solo agregamos si tiene valor (no es null, undefined ni string vacío)
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });
 
      return `${API_BASE}/precioProductoEess/list?${params.toString()}`;
    },
  },
 
productos: {
    // Endpoint base para POST (Crear) y PUT (Editar)
    create: `${API_BASE}/productos/agregar`,
    update: (id) => `${API_BASE}/productos/${id}/editar`,
    delete: (id) => `${API_BASE}/productos/${id}/eliminar`,
 
    //Autocomplete
    autocomplete: (q = "", page = 0, size = 20) =>
      `${API_BASE}/productos/autocomplete`
      + `?q=${encodeURIComponent(q)}`
      + `&page=${page}`
      + `&size=${size}`,

    //Reporte de Productos asignados a Tarjetas, por Cuenta.
    exportar: (params) => `${API_BASE}/productos/exportarProductosAsignadosTarjetaPorCuentaExcel?${params.toString()}`,
    exportarPdf: (params) => `${API_BASE}/productos/exportarProductosAsignadosTarjetaPorCuentaPDF?${params.toString()}`,
   
    // Función para generar la URL de listado con todos los filtros
    listUrl: ({
      page = 0,
      size = 30,
      q = "",
      codigo = "",
      estadoId = null,
      rubroId = null,
      ivaId = null,
      unidadMedidaId = null,
      codigoSap = "",
    } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
 
      // Filtros de texto
      if (q) params.set("q", q.trim());
      if (codigo) params.set("codigo", codigo.trim());
      if (codigoSap) params.set("codigoSap", codigoSap.trim());
 
      // Filtros de ID (Combos)
      if (estadoId) params.set("estadoId", estadoId);
      if (rubroId) params.set("rubroId", rubroId);
      if (ivaId) params.set("ivaId", ivaId);
      if (unidadMedidaId) params.set("unidadMedidaId", unidadMedidaId);
 
      return `${API_BASE}/productos/list?${params.toString()}`;
    },
  },
    // --- Catálogos para el modal de Productos --- Inicio
  rubros: {
    create: `${API_BASE}/rubro/agregar`,
    update: (id) => `${API_BASE}/rubro/${id}/editar`,
    delete: (id) => `${API_BASE}/rubro/${id}/eliminar`,
    listUrl: ({
      page = 0,
      size = 30,
      nombre = "",
      codigo = "",
    } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if (nombre) params.set("nombre", nombre.trim());
      if (codigo) params.set("codigo", codigo.trim());
      return `${API_BASE}/rubro/list?${params.toString()}`;
    },
  },
ivas: {
    create: `${API_BASE}/iva/agregar`,
    update: (id) => `${API_BASE}/iva/${id}/editar`,
    delete: (id) => `${API_BASE}/iva/${id}/eliminar`,
    listUrl: ({ page = 0, size = 30, codigo = "", nombre = "", pr = "" } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        params.set("size", String(size));
        if (codigo) params.set("codigo", codigo.trim());
        if (nombre) params.set("nombre", nombre.trim());
        if (pr) params.set("pr", String(pr));
        return `${API_BASE}/iva/list?${params.toString()}`;
    },
},
  unidadesMedida: {
    list: `${API_BASE}/unidadMedida/list`,
    listUrl: ({ page = 0, size = 100 } = {}) => `${API_BASE}/unidadMedida/list?page=${page}&size=${size}`,
  },
    // --- Catálogos para el modal de Productos --- Fin
 
  procesos: {
    list: `${API_BASE}/procesos/list`,
 
    listUrl: ({ page = 0, size = 30, q = "" } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if (q != null && String(q).trim() !== "") params.set("q", q.trim());
 
      return `${API_BASE}/procesos/list?${params.toString()}`;
    },
    
    
    detail: (id) => `${API_BASE}/procesos/${id}`,
    ejecutar: (id) => `${API_BASE}/procesos/${id}/ejecutar`,
 
    // ✅ AUTOCOMPLETE
    autocompleteUrl: ({ q = "", page = 0, size = 20 } = {}) => {
      const params = new URLSearchParams();
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      params.set("page", String(page));
      params.set("size", String(size));
      return `${API_BASE}/procesos/autocomplete?${params.toString()}`;
    },
    listFiles: `${API_BASE}/procesos/listfiles`,
  },
 
  estadoTipo: {
    list: `${API_BASE}/estadoTipo/list`,
 
    listUrl: ({ page = 0, size = 30, q = "" } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      return `${API_BASE}/estadoTipo/list?${params.toString()}`;
    },
    //Autocomplete filtro
    autocomplete: `${API_BASE}/estadoTipo/autocomplete`,
 
    autocompleteUrl: (q = "", page = 0, size = 20) => {
      const params = new URLSearchParams();
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      params.set("page", String(page));
      params.set("size", String(size));
      return `${API_BASE}/estadoTipo/autocomplete?${params.toString()}`;
    },
    //Insertar
    create: `${API_BASE}/estadoTipo/agregar`,
    //Borrar
    deleteUrl: (id) =>
      `${API_BASE}/estadoTipo/${encodeURIComponent(id)}/eliminar`,
    //Detalles: Obtiene de GetID en vez de la lista
    detail: (id) => `${API_BASE}/estadoTipo/${encodeURIComponent(id)}`,
    //Actualizar
    update: (id) => `${API_BASE}/estadoTipo/${encodeURIComponent(id)}/editar`,
  },
 
  estado: {
    // Listar
    list: `${API_BASE}/estados/list`,
    autocomplete: () => `${API_BASE}/estados/autocomplete`,
    listUrl: ({ page = 0, size = 30, q = "", tipoId } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
 
      // ✅ NUEVO: filtrar por tipo de estado (EstadoTipo.id)
      if (tipoId != null && String(tipoId).trim() !== "")
        params.set("tipoId", String(tipoId));
 
      return `${API_BASE}/estados/list?${params.toString()}`;
    },
    // 🔴 ESTE ERA CLAVE PARA EDITAR
    detail: (id) => `${API_BASE}/estados/${encodeURIComponent(id)}`,
    // 🔴 ESTE ERA CLAVE PARA EDITAR
    update: (id) => `${API_BASE}/estados/${encodeURIComponent(id)}/editar`,
    // Crear
    create: `${API_BASE}/estados/agregar`,
    // Eliminar
    deleteUrl: (id) => `${API_BASE}/estados/${encodeURIComponent(id)}/eliminar`,
  },
 
  informacion: {
    list: `${API_BASE}/informacion/list`,
    listUrl: ({ page = 0, size = 1000, q = "", fecha = "", clienteId, eessId } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
 
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      if ((fecha ?? "").trim() !== "") params.set("fecha", fecha.trim());
      if (clienteId) params.set("clienteId", clienteId);
      if (eessId) params.set("eessId", eessId); // <-- NUEVO
 
      return `${API_BASE}/informacion/list?${params.toString()}`;
    },
    deleteUrl: (id) =>
      `${API_BASE}/informacion/${encodeURIComponent(id)}/eliminar`,
    create: `${API_BASE}/informacion/agregar`,
    // 🔥 NUEVO — EDITAR
    editInit: (id) =>
      `${API_BASE}/informacion/${encodeURIComponent(id)}/editar`,
    update: (id) => `${API_BASE}/informacion/${encodeURIComponent(id)}/editar`,
  },
 
  parametros: {
    list: `${API_BASE}/parametros/list`,
 
    listUrl: ({
      page = 0,
      size = 30,
      nombre,
      valor,
      fecha,
      numero,
      prioridad,
    } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
 
      if ((nombre ?? "").trim() !== "") params.set("nombre", nombre.trim());
      if ((valor ?? "").trim() !== "") params.set("valor", valor.trim());
      if ((fecha ?? "").trim() !== "") params.set("fecha", fecha.trim());
      if (numero != null && String(numero).trim() !== "")
        params.set("numero", String(numero));
      if (prioridad != null && String(prioridad).trim() !== "")
        params.set("prioridad", String(prioridad));
 
      return `${API_BASE}/parametros/list?${params.toString()}`;
    },
    // ===== AUTOCOMPLETE DE PARÁMETROS =====
    autocompleteUrl: ({ q = "", page = 0, size = 20 } = {}) => {
      const params = new URLSearchParams();
      params.set("q", q);
      params.set("page", String(page));
      params.set("size", String(size));
      return `${API_BASE}/parametros/autocomplete?${params.toString()}`;
    },
    create: `${API_BASE}/parametros/agregar`,
    update: (id) => `${API_BASE}/parametros/${id}/editar`,
    delete: (id) => `${API_BASE}/parametros/${id}/eliminar`,
  },

/*josefer */
  // 📤 PROANI OUT (Datos exportados)
  proaniOut: {
    list: `${API_BASE}/proaniOut/list`,

    listUrl: ({
      page = 0,
      size = 30,
      dataFecha,
      codigoTipo,
      nombreArchivo,
      textoLinea,
      descricaoError,
      codigoProcesado,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("size", size);

      if (dataFecha) params.set("dataFecha", dataFecha);
      if (codigoTipo) params.set("codigoTipo", codigoTipo);
      if (nombreArchivo) params.set("nombreArchivo", nombreArchivo);
      if (textoLinea) params.set("textoLinea", textoLinea);
      if (descricaoError) params.set("descricaoError", descricaoError);
      if (codigoProcesado) params.set("codigoProcesado", codigoProcesado);

      return `${API_BASE}/proaniOut/list?${params.toString()}`;
    },

    exportExcelUrl: (params = {}) => {
      const usp = new URLSearchParams();
      Object.entries(params).forEach(([k, v]) => {
        if (v != null && String(v).trim() !== "") usp.set(k, String(v));
      });
      return `${API_BASE}/proaniOut/export/excel?${usp.toString()}`;
    },
    detail: (id) => `${API_BASE}/proaniOut/${id}`,
  },


  liquidacionEess: {
    list: `${API_BASE}/liquidacionEess/list`,

    listUrl: ({ page = 0, size = 30, ...filters } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });

      return `${API_BASE}/liquidacionEess/list?${params.toString()}`;
    },

    // ✅ NUEVO
    exportar: (params) =>
      `${API_BASE}/liquidacionEess/reportAcreditacionEess?${params.toString()}`,
  },


  liquidacionCliente: {
    list: `${API_BASE}/liquidacionCliente/list`,

    listUrl: ({ page = 0, size = 30, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      Object.entries(filters).forEach(([key, value]) => {
        if (value !== null && value !== undefined && String(value).trim() !== "") {
          params.set(key, String(value).trim());
        }
      });

      return `${API_BASE}/liquidacionCliente/list?${params.toString()}`;
    },
    // ✅ Reporte
    // Excel
    exportar: (params) =>
      `${API_BASE}/liquidacionCliente/exportarDetalleFacturacionClienteExcel?${params.toString()}`,
    
    // PDF
    exportarPdf: (params) =>
      `${API_BASE}/liquidacionCliente/exportarDetalleFacturacionClientePDF?${params.toString()}`,
  },


  // 📄 Facturas Generadas
  facturas: {
    list: `${API_BASE}/factura/list`,

    listUrl: ({
      page = 0,
      size = 30,

      // filtros
      clienteId,
      numero,
      numeroNotacredito,
      facturaClienteId,
      estadoId,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));
      if (clienteId != null) {
        params.set("clienteId", String(clienteId));
      }
      if (numero) params.set("numero", numero.trim());
      if (numeroNotacredito) params.set("numeroNotacredito", numeroNotacredito.trim());
      if (facturaClienteId != null) params.set("facturaClienteId", String(facturaClienteId));
      if (estadoId != null) params.set("estadoId", String(estadoId));

      return `${API_BASE}/factura/list?${params.toString()}`;
    },
    detail: (id) => `${API_BASE}/factura/${id}`,
  },

  liquidacion: {
    autocomplete: ({
      q,
      page = 0,
      size = 20,
    } = {}) => {
      const params = new URLSearchParams();

      if (q && q.trim() !== "") {
        params.set("descripcion", q.trim()); // 🔑 coincide con LiquidacionRequestDto
      }

      params.set("page", String(page));
      params.set("size", String(size));

      return `${API_BASE}/liquidacion/autocomplete?${params.toString()}`;
    },
    list: ({
      page = 0,
      size = 30,
      descripcion,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));

      if (descripcion && descripcion.trim() !== "") {
        params.set("descripcion", descripcion.trim());
      }

      return `${API_BASE}/liquidacion/list?${params.toString()}`;
    },
    detail: (id) =>`${API_BASE}/liquidacion/${id}`,
    delete: (id) =>`${API_BASE}/liquidacion/${id}`,
    update: (id) => `${API_BASE}/liquidacion/${id}/editar`,
    create: () => `${API_BASE}/liquidacion/crear`,
  },
  // facturacion de clientes por liquidacion 
  facturaLiquidacionCliente: {
    create: () => `${API_BASE}/facturaCliente/crear`,
    detail: (id) =>`${API_BASE}/facturaCliente/${id}`,
    delete: (id) =>`${API_BASE}/facturaCliente/${id}/eliminar`,
    list: ({
      page = 0,
      size = 30,
      clienteId,
      liquidacionId,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));

      if (clienteId != null) {
        params.set("clienteId", String(clienteId));
      }

      if (liquidacionId != null) {
        params.set("liquidacionId", String(liquidacionId));
      }

      return `${API_BASE}/facturaCliente/list?${params.toString()}`;
    },
    autocompleteUrl: ({
      q = "",
      page = 0,
      size = 20,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));
      if (q) params.set("q", q);

      return `${API_BASE}/facturaCliente/autocomplete?${params.toString()}`;
    },
  },
  zonas: {
    create: `${API_BASE}/zona/agregar`,
    update: (id) => `${API_BASE}/zona/${id}/editar`,
    delete: (id) => `${API_BASE}/zona/${id}/eliminar`,
    listUrl: ({ page = 0, size = 30, nombre = "" } = {}) => {
        const params = new URLSearchParams();
        params.set("page", String(page));
        params.set("size", String(size));
        if (nombre) params.set("nombre", nombre.trim());
        return `${API_BASE}/zona/list?${params.toString()}`;
    },
},

  // CIUDAD
  ciudad: {
    autocompleteUrl: ({
      q,
      page = 0,
      size = 20,
    } = {}) => {
      const params = new URLSearchParams();

      if (q) params.set("q", q);
      params.set("page", String(page));
      params.set("size", String(size));

      return `${API_BASE}/ciudad/autocomplete?${params.toString()}`;
    },
  },
  // ⛽ Estaciones de Servicio (EESS)
  eess: {
    list: `${API_BASE}/eess/list`,
    detail: (id) => `${API_BASE}/eess/${id}`,
    editar: (id) => `${API_BASE}/eess/${id}/editar`,
    inactivarPines: `${API_BASE}/eess/pines/inactivar`,
    listUrl: ({
      page = 0,
      size = 30,

      codigoEstacion,
      nombreEstacion,
      descricaoDireccion,
      descricaoRuc,
      descricaoEmail,
      dataAlta,
      zonaId,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", page);
      params.set("size", size);

      if (codigoEstacion) params.set("codigoEstacion", codigoEstacion);
      if (nombreEstacion) params.set("nombreEstacion", nombreEstacion);
      if (descricaoDireccion) params.set("descricaoDireccion", descricaoDireccion);
      if (descricaoRuc) params.set("descricaoRuc", descricaoRuc);
      if (descricaoEmail) params.set("descricaoEmail", descricaoEmail);
      if (dataAlta) params.set("dataAlta", dataAlta);
      if (zonaId) params.set("zona.id", zonaId);

      return `${API_BASE}/eess/list?${params.toString()}`;
    },

  },
  // 💸 Descuento Flota
  descuentoFlota: {
    list: `${API_BASE}/descuentoFlota/list`,

    listUrl: ({
      page = 0,
      size = 30,

      // relaciones
      clienteId,
      eessId,
      productoId,
      tarjetaId,

      // valores
      totalValor,      // valorDescuento
      totalPct,        // prDescuento

      valorEess,
      pctEess,

      valorPetr,
      pctPetr,

      valorLibe,

      // fechas
      fechaInicio,
      fechaFin,
    } = {}) => {
      const params = new URLSearchParams();

      // =========================
      // PAGINACIÓN
      // =========================
      params.set("page", String(page));
      params.set("size", String(size));

      // =========================
      // RELACIONES
      // =========================
      if (clienteId != null) params.set("clienteId", clienteId);
      if (eessId != null) params.set("eessId", eessId);
      if (productoId != null) params.set("productoId", productoId);
      if (tarjetaId != null) params.set("tarjetaId", tarjetaId);

      // =========================
      // VALORES DESCUENTO
      // =========================
      if (totalValor != null) params.set("valorDescuento", totalValor);
      if (totalPct != null) params.set("prDescuento", totalPct);

      if (valorEess != null) params.set("valorEess", valorEess);
      if (pctEess != null) params.set("prEess", pctEess);

      if (valorPetr != null) params.set("valorPetr", valorPetr);
      if (pctPetr != null) params.set("prPetr", pctPetr);

      if (valorLibe != null) params.set("valorLibe", valorLibe);

      // =========================
      // FECHAS (ISO yyyy-MM-dd)
      // =========================
      if (fechaInicio) params.set("fechaInicio", fechaInicio);
      if (fechaFin) params.set("fechaFin", fechaFin);

      return `${API_BASE}/descuentoFlota/list?${params.toString()}`;
    },
    create: `${API_BASE}/descuentoFlota/crear`,
    detail: (id) => `${API_BASE}/descuentoFlota/${id}`,
    delete: (id) => `${API_BASE}/descuentoFlota/${id}/eliminar`,
    update: (id) => `${API_BASE}/descuentoFlota/${id}/editar`,
  },


  // 🔑 Pines (CLIENTES)
  pines: {
    reportPinesEess: (params) =>
      `${API_BASE}/pines/reportPinesEess?${params.toString()}`,
    list: `${API_BASE}/pines/clientes/list`,
    // PINES PLAYEROS (LISTADO)
    listPlayeros: ({
      page = 0,
      size = 30,
      eessId,
      numero,
      numeroResponsable,
      estadoId,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));

      if (eessId != null) params.set("eessId", String(eessId));
      if (numero != null) params.set("numero", String(numero));
      if (numeroResponsable != null) params.set("numeroResponsable", String(numeroResponsable));
      if (estadoId != null) params.set("estadoId", String(estadoId));

      return `${API_BASE}/pines/playeros/list?${params.toString()}`;
    },
    // PINES MAESTROS (LISTADO) 🆕
    listMaestros: ({
      page = 0,
      size = 30,
      eessId,
      numero,
      numeroResponsable,
      estadoId,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));
      if (eessId != null) params.set("eessId", String(eessId));
      if (numero != null) params.set("numero", String(numero));
      if (numeroResponsable != null) params.set("numeroResponsable", String(numeroResponsable));
      if (estadoId != null) params.set("estadoId", String(estadoId));

      return `${API_BASE}/pines/maestros/list?${params.toString()}`;
    },
    // 🔥 NUEVO: Pines inactivables (autocomplete)
    inactivables: ({
      tipo,          // PLAYERO | MAESTRA (obligatorio)
      eessId,        // requerido para ADMIN
      page = 0,
      size = 25,
    } = {}) => {
      const params = new URLSearchParams();

      params.set("page", String(page));
      params.set("size", String(size));

      if (tipo != null) params.set("tipo", String(tipo));
      if (eessId != null) params.set("eessId", String(eessId));

      return `${API_BASE}/pines/inactivables?${params.toString()}`;
    },
    listUrl: ({ page = 0, size = 30, clienteId, numero, numeroResponsable, tipo, estadoId } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      if (clienteId != null) params.set("clienteId", String(clienteId));
      if (numero != null) params.set("numero", String(numero));
      if (numeroResponsable != null) params.set("numeroResponsable", String(numeroResponsable));
      if (tipo != null && String(tipo).trim() !== "") params.set("tipo", String(tipo));
      if (estadoId != null) params.set("estadoId", String(estadoId));

      return `${API_BASE}/pines/list?${params.toString()}`;
    },
    detail: (id) => `${API_BASE}/pines/${encodeURIComponent(id)}`,   
    update: (id) => `${API_BASE}/pines/${id}/editar`,
    generarCliente: `${API_BASE}/pines/generar/clientes`,
    generarPlayero: `${API_BASE}/pines/generar/playero`,
    generarMaestro: `${API_BASE}/pines/generar/maestro`,
  // ✅ EXPORTACIONES
    //Excel
    exportar: (params) =>
      `${API_BASE}/pines/exportar?${params.toString()}`,
    //PDF
    exportarPdf: (params) =>
      `${API_BASE}/pines/exportar-pdf?${params.toString()}`,
  },
  // 🔒 Permisos (Seguridad)
  permisos: {
    create: `${API_BASE}/permisos/crear`,
    deleteUrl: (id) => `${API_BASE}/permisos/${encodeURIComponent(id)}`,
    list: `${API_BASE}/permisos/list`,
    updateAccion: `${API_BASE}/permisos/accion`,
    autocomplete: `${API_BASE}/permisos/autocomplete`,

    autocompleteUrl: (tipo = "modulo", q = "", page = 0, size = 50) => {
      const params = new URLSearchParams();
      params.set("tipo", String(tipo));
      if ((q ?? "").trim() !== "") params.set("q", String(q).trim());
      params.set("page", String(page));
      params.set("size", String(size));
      return `${API_BASE}/permisos/autocomplete?${params.toString()}`;
    },

    listUrl: (op = {}) => {
      const {
        page = 0,
        size = 30,
        q,
        modulo,
        accion,
        sort, // string | string[]
        ...rest
      } = op;
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      if (q != null && String(q) !== "") params.set("q", String(q));
      if (modulo != null && String(modulo) !== "") params.set("modulo", String(modulo));
      if (accion != null && String(accion) !== "") params.set("accion", String(accion));
      const pushSort = (s) => {
        if (!s) return;
        const v = String(s).trim();
        if (v) params.append("sort", v);
      };
      if (Array.isArray(sort)) sort.forEach(pushSort);
      else pushSort(sort);
      Object.entries(rest).forEach(([k, v]) => {
        if (v !== undefined && v !== null && String(v) !== "") {
          params.set(k, String(v));
        }
      });
      return `${API_BASE}/permisos/list?${params.toString()}`;
    },
    // ✅ Autocomplete de MÓDULOS servido por PermisoController (tipo=modulo)
    autocompleteModulo: `${API_BASE}/permisos/autocomplete?tipo=modulo`,
    autocompleteModuloUrl: (q = "", page = 0, size = 100) => {
      const params = new URLSearchParams();
      params.set("tipo", "modulo");
      if (q != null && String(q).trim() !== "") params.set("q", String(q).trim());
      params.set("page", String(page));
      params.set("size", String(size));
      return `${API_BASE}/permisos/autocomplete?${params.toString()}`;
    },
  },

  // 👥 Clientes
  clientes: {
    grupos: `${API_BASE}/clientes/grupos`,
    list: `${API_BASE}/clientes/list`,

    // --- Se agregó esto para el multiSelect Clientes y Certificados---
   listUrl: ({ page = 0, size = 1000, ...filters } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      
      // TRUCO: Activamos 'browse' para que el autocomplete se comporte como una lista normal
      params.set("browse", "true"); 
      params.set("tipo", "cliente");

      if (filters.nombre) params.set("q", filters.nombre);

      // Apuntamos a /autocomplete porque es el único que responde en tu servidor
      return `${API_BASE}/clientes/autocomplete?${params.toString()}`;
    },
    // --------------------

    detail: (id) => `${API_BASE}/clientes/${encodeURIComponent(id)}`,
    add: `${API_BASE}/clientes/add`,
    update: (id) => `${API_BASE}/clientes/${encodeURIComponent(id)}/editar`,
    delete: (id) => `${API_BASE}/clientes/delete/${encodeURIComponent(id)}`,
    autocomplete: `${API_BASE}/clientes/autocomplete`,
    // ⬇️ CORREGIDO: soporta browse (para listar sin q), tipo, grupos y estado
    autocompleteUrl: ({
      q = "",
      page = 0,
      size = 100,
      tipo = "cliente",      // cliente | nombre | documento | codigo | grupo
      browse = false,        // true => permite “explorar” sin q
      grupoId,               // number | number[]
      estadoId,              // opcional
    } = {}) => {
      const params = new URLSearchParams();
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      params.set("page", String(page));
      params.set("size", String(size));
      params.set("tipo", String(tipo));
      params.set("browse", String(browse));
      if (estadoId != null) params.set("estadoId", String(estadoId));
      if (Array.isArray(grupoId)) grupoId.forEach((g) => params.append("grupoId", String(g)));
      else if (grupoId != null) params.append("grupoId", String(grupoId));
      return `${API_BASE}/clientes/autocomplete?${params.toString()}`;
    },
    estados: `${API_BASE}/clientes/estados`,
    combo: `${API_BASE}/clientes/combo`,
        // --- REPORTE: Periodos de Facturación de Clientes ---
    exportarFacturacionClientesExcel: (params) => `${API_BASE}/clientes/exportarFacturacionClientesExcel?${params.toString()}`,
    exportarFacturacionClientesPdf: (params) => `${API_BASE}/clientes/exportarFacturacionClientesPdf?${params.toString()}`,
  },

  limiteCredito: {
    list: `${API_BASE}/limite-credito/list`,
    crear: `${API_BASE}/limite-credito/crear`,
    detail: (id) => `${API_BASE}/limite-credito/${encodeURIComponent(id)}`,
    initByCliente: (clienteId) =>
      `${API_BASE}/limite-credito/cliente/${encodeURIComponent(clienteId)}/init`,
    delete: (id) =>
      `${API_BASE}/limite-credito/${encodeURIComponent(id)}/eliminar`,
    resolver: (id) =>
    `${API_BASE}/limite-credito/${encodeURIComponent(id)}/resolver`,
  },

  // 🔁 Tarjetas
  tarjetas: {
    // 📄 Reporte Tarjetas Maestras
    exportarMaestras: (params) =>`${API_BASE}/tarjetas/reportTarjetasMaestras?${params.toString()}`,
    //Excel
    exportar: (params) => `${API_BASE}/tarjetas/exportarListadoTarjetasExcel?${params.toString()}`,
   //PDF:
    exportarPdf: (params) => 
      `${API_BASE}/tarjetas/exportarListadoTarjetasPDF?${params.toString()}`,

    // ✅ Límite de crédito masivo
    limitesMasivo: {
      exportar: (clienteIds = []) => {
        const params = new URLSearchParams();

        clienteIds.forEach((id) => {
          if (id != null && String(id).trim() !== "") {
            params.append("clienteId", String(id));
          }
        });

        return `${API_BASE}/tarjetas/limites-masivo/exportar?${params.toString()}`;
      },

      importar: `${API_BASE}/tarjetas/limites-masivo/importar`,
    },
    
    list: `${API_BASE}/tarjetas/list`,
    listUrl: (payload = {}) => {
      const {
        page = 0,
        size = 30,
        clienteId,
        tarjetaNumero,
        vehiculoIdsCsv,
        tarjetaId,
        numero,
        vehiculoId,
        ...rest
      } = payload;
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));

      if (clienteId != null) params.set("clienteId", String(clienteId));
      if (tarjetaId != null) params.set("tarjetaId", String(tarjetaId));

      if (tarjetaNumero != null && tarjetaNumero !== "") {
        params.set("numero", String(tarjetaNumero));
      } else if (numero != null && numero !== "") {
        params.set("numero", String(numero));
      }

      if (vehiculoId != null) {
        params.set("vehiculoId", String(vehiculoId));
      } else if (vehiculoIdsCsv) {
        const firstVehId = String(vehiculoIdsCsv)
          .split(",")
          .map((s) => s.trim())
          .filter(Boolean)[0];
        if (firstVehId) params.set("vehiculoId", firstVehId);
      }

      Object.entries(rest).forEach(([k, v]) => {
        if (v !== undefined && v !== null && String(v) !== "") {
          params.set(k, String(v));
        }
      });

      return `${API_BASE}/tarjetas/list?${params.toString()}`;
    },
    detail: (id) => `${API_BASE}/tarjetas/${encodeURIComponent(id)}`,
    editInit: (id) => `${API_BASE}/tarjetas/${encodeURIComponent(id)}/editar`,
    add: `${API_BASE}/tarjetas/add`,
    update: (id) => `${API_BASE}/tarjetas/${encodeURIComponent(id)}/editar`,
    delete: (id) => `${API_BASE}/tarjetas/delete/${encodeURIComponent(id)}`,
    estados: `${API_BASE}/tarjetas/estados`,
    solicitarCliente: `${API_BASE}/tarjetas/solicitar1`,
    solicitarMaestra: `${API_BASE}/tarjetas/solicitar2`,
    solicitarPrepaga: `${API_BASE}/tarjetas/solicitar3`,
    // ✅ NUEVO helper prolijo
    autocompleteUrl: (tipo = "numero", q = "", page = 0, size = 10, estadoIds = null) => {
      const params = new URLSearchParams();

      params.set("tipo", String(tipo));
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      params.set("page", String(page));
      params.set("size", String(size));

      // Compatible:
      // - número simple: manda estadoId=29
      // - array: manda estadoIds=27&estadoIds=29
      // - null/undefined: no manda estado, lista todas
      if (Array.isArray(estadoIds)) {
        estadoIds.forEach((id) => {
          if (id != null && String(id).trim() !== "") {
            params.append("estadoIds", String(id));
          }
        });
      } else if (estadoIds != null && String(estadoIds).trim() !== "") {
        params.set("estadoId", String(estadoIds));
      }

      return `${API_BASE}/tarjetas/autocomplete?${params.toString()}`;
    },
    autocomplete: (tipo = "numero", q = "", page = 0, size = 10) =>
      `${API_BASE}/tarjetas/autocomplete?tipo=${encodeURIComponent(tipo)}&q=${encodeURIComponent(q)}&page=${page}&size=${size}`,

    replaceAsignaciones: (tarjetaId, tipo /* "estacion" | "producto" */) =>
      `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/asignar/${encodeURIComponent(tipo)}`,
  },

  tarjetaConfig: {
    permisos: {
      list: (tarjetaId, page = 0, size = 25, estadoId = null) => {
        const base = `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/permisos?page=${page}&size=${size}`;
        return estadoId != null
          ? `${base}&estadoId=${encodeURIComponent(estadoId)}`
          : base;
      },
      create: (tarjetaId) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/permisos`,
      update: (id) =>
        `${API_BASE}/tarjetas/configuraciones/permisos/${encodeURIComponent(id)}`,
      delete: (id) =>
        `${API_BASE}/tarjetas/configuraciones/permisos/${encodeURIComponent(id)}`,
      deactivateAll: (tarjetaId) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/permisos/estado/inactivo`,
      deactivateByTipo: (tarjetaId, tipo) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/permisos/estado/inactivo/${encodeURIComponent(tipo)}`,
      patchNotifica: (tarjetaId, tipo, notifica) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/permisos/notifica?tipo=${encodeURIComponent(tipo)}&notifica=${encodeURIComponent(notifica)}`,
      deleteLimiteCredito: (tarjetaId) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/permisos/limite-credito`,
    },

    alertas: {
      list: (tarjetaId, page = 0, size = 25, estadoId = null) => {
        const base = `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/alertas?page=${page}&size=${size}`;
        return estadoId != null
          ? `${base}&estadoId=${encodeURIComponent(estadoId)}`
          : base;
      },
      create: (tarjetaId) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/alertas`,
      update: (id) =>
        `${API_BASE}/tarjetas/configuraciones/alertas/${encodeURIComponent(id)}`,
      delete: (id) =>
        `${API_BASE}/tarjetas/configuraciones/alertas/${encodeURIComponent(id)}`,
      deactivateAll: (tarjetaId) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/alertas/estado/inactivo`,
      deactivateByTipo: (tarjetaId, tipo) =>
        `${API_BASE}/tarjetas/${encodeURIComponent(tarjetaId)}/configuraciones/alertas/estado/inactivo/${encodeURIComponent(tipo)}`,
    },
 
  },

  // 🚗 Vehículos con Tarjeta
  vehiculosConTarjeta: {
    list: `${API_BASE}/vehiculo/list`,
    detail: (id) => `${API_BASE}/vehiculo/${encodeURIComponent(id)}`,
    editInit: (id) => `${API_BASE}/vehiculo/${encodeURIComponent(id)}/editar`,
    update: (id) => `${API_BASE}/vehiculo/${encodeURIComponent(id)}/editar`,
    autocomplete: `${API_BASE}/vehiculo/autocomplete`,
  },

  // 🧾 Producto ↔ Tarjeta
  productoTarjeta: {
    list: `${API_BASE}/productoTarjeta/list`,
    detail: (id) => `${API_BASE}/productoTarjeta/${encodeURIComponent(id)}`,
    delete: (id) => `${API_BASE}/productoTarjeta/${encodeURIComponent(id)}`,
    autocomplete: `${API_BASE}/productoTarjeta/autocomplete`,
    autocomplete2: (tipo = "tarjeta", q = "", page = 0, size = 10) =>
      `${API_BASE}/productoTarjeta/autocomplete?tipo=${encodeURIComponent(tipo)}&q=${encodeURIComponent(q)}&page=${page}&size=${size}`,
    autocompleteUrl: (tipo = "producto", q = "", page = 0, size = 10, full = null) => {
      const base = `${API_BASE}/productoTarjeta/autocomplete?tipo=${encodeURIComponent(tipo)}&q=${encodeURIComponent(q)}&page=${page}&size=${size}`;
      return full != null ? `${base}&full=${encodeURIComponent(full)}` : base;
    },
    asignados: (tarjetaId, page = 0, size = 500) =>
      `${API_BASE}/productoTarjeta/${encodeURIComponent(tarjetaId)}/asignados?page=${page}&size=${size}`,
  },
  // 👤 Usuarios (otros módulos)
  usuarios: {
    list: `${API_BASE}/usuarios/list`,
    listUrl: ({ estadoIds = 29, page = 0, size = 30, nombre } = {}) => {
      const params = new URLSearchParams();
      params.set("page", String(page));
      params.set("size", String(size));
      params.set("estadoIds", String(estadoIds));
      if ((nombre ?? "").trim() !== "") params.set("nombre", nombre.trim());
      return `${API_BASE}/usuarios/list?${params.toString()}`;
    },
    autocomplete: `${API_BASE}/usuarios/autocomplete`,
    detail: (id) => `${API_BASE}/usuarios/${encodeURIComponent(id)}`,
    editInit: (id) => `${API_BASE}/usuarios/${encodeURIComponent(id)}/editar`,
    update:  (id) => `${API_BASE}/usuarios/${encodeURIComponent(id)}/editar`,
    create: `${API_BASE}/usuarios/agregar`,
    deleteUrl: (id) => `${API_BASE}/usuarios/${encodeURIComponent(id)}/eliminar`,
    updateClave: (id) =>
      `${API_BASE}/usuarios/${encodeURIComponent(id)}/clave`,
  },

  // ⛽ EE.SS. habilitadas por Tarjeta
  eessHabilitadas: {
    list: `${API_BASE}/tarjeta-eess/list`,
    delete: (id) => `${API_BASE}/tarjeta-eess/${encodeURIComponent(id)}`,
    autocomplete: (tipo = "eess", q = "", page = 0, size = 10) =>
      `${API_BASE}/tarjeta-eess/autocomplete?tipo=${encodeURIComponent(tipo)}&q=${encodeURIComponent(q)}&page=${page}&size=${size}`,
    autocompleteUrl: (tipo = "eess", q = "", page = 0, size = 10, full = null, flota = "SI") => {
      const base = `${API_BASE}/tarjeta-eess/autocomplete?tipo=${encodeURIComponent(tipo)}&q=${encodeURIComponent(q)}&page=${page}&size=${size}`;

      let url = base;

      if (full != null) url += `&full=${encodeURIComponent(full)}`;
      if (flota != null) url += `&flota=${encodeURIComponent(flota)}`;

      return url;
    },
    asignadas: (tarjetaId, page = 0, size = 500) =>
      `${API_BASE}/tarjeta-eess/${encodeURIComponent(tarjetaId)}/asignadas?page=${page}&size=${size}`,
  },

  // 🧩 Roles
  roles: {
    list: `${API_BASE}/roles/list`,
    listUrl: (page = 0, size = 30) =>
      `${API_BASE}/roles/list?page=${encodeURIComponent(page)}&size=${encodeURIComponent(size)}`,

    // ✅ NUEVO: autocomplete
    autocomplete: `${API_BASE}/roles/autocomplete`,
    autocompleteUrl: (q = "", page = 0, size = 100) => {
      const params = new URLSearchParams();
      if ((q ?? "").trim() !== "") params.set("q", q.trim());
      params.set("page", String(page));
      params.set("size", String(size));
      return `${API_BASE}/roles/autocomplete?${params.toString()}`;
    },

    editInit: (id) => `${API_BASE}/roles/${encodeURIComponent(id)}/editar`,
    update: (id) => `${API_BASE}/roles/${encodeURIComponent(id)}/editar`,
    create: `${API_BASE}/roles/crear`,

    permisos: {
      list: (rolId, page = 0, size = 100) =>
        `${API_BASE}/roles/${encodeURIComponent(rolId)}/permisos?page=${page}&size=${size}`,
    patch: (rolId) =>
        `${API_BASE}/roles/${encodeURIComponent(rolId)}/permisos`,
    },

    add: `${API_BASE}/roles/add`,
    delete: (id) => `${API_BASE}/roles/eliminar/${encodeURIComponent(id)}`,
  },

  // 📦 Lotes de Tarjetas
  lotes: {
    list: `${API_BASE}/loteTarjeta/list`,
    estados: `${API_BASE}/loteTarjeta/estados`,
    idsSuggest: `${API_BASE}/loteTarjeta/ids/suggest`,
    generarArchivo: (loteId) =>
      `${API_BASE}/loteTarjeta/generarArchivo?loteId=${encodeURIComponent(loteId)}`,
    cerrar: (loteId) =>
      `${API_BASE}/loteTarjeta/${encodeURIComponent(loteId)}/cerrar`,
    tarjetasDeLote: (loteId, page = 0, size = 10) =>
      `${API_BASE}/loteTarjeta/${encodeURIComponent(loteId)}/tarjetas?page=${page}&size=${size}`,
  },
};

export default apiRoutes;
